import React from 'react';

import {
	Table as BootstrapTable,
	Button,
	Row,
	Col,
	FormGroup,
	InputGroup,
	OverlayTrigger,
	Tooltip
} from 'react-bootstrap'
import Header from './Header'
import Body from './Body'
import Pagination from './Pagination'

import Select from 'react-select';
import 'react-select/dist/react-select.css';

const Table = props => {
	let {
		schema,
		data,
		count,
		handlePaginate,
		activePage,
		isLoading,
		isExporting,
		handleModalShow,
		stateSetter,
		getTableData,
		exportData,
		loadOptions,
		accessible,
		sort,
		tableCustomId,
		buttonCustomId,
		actionCustomId,
		customCreate,
		customUpdate,
		customDelete,
		customView,
		customAction,
		customItems,
		additionalButtons,
		filter,
		query,
		showButtonActionAsText
	} = props;
	// console.log('schema', schema)

	let paginationState = {
		itemsCountPerPage: schema.limit || 10,
		totalItemsCount: count || 0,
		handlePaginate,
		activePage
	}

	let bodyState = {
		data,
		schema,
		isLoading,
		handleModalShow,
		accessible,
		buttonCustomId,
		actionCustomId,
		customUpdate,
		customDelete,
		customView,
		customAction,
		customItems,
		getTableData,
		showButtonActionAsText
	}

	let customId = typeof tableCustomId !== 'undefined'
		? tableCustomId
		: ''

	let customButtonId = typeof buttonCustomId !== 'undefined'
		? buttonCustomId
		: ''

	const isUndefined = (obj) => typeof obj === 'undefined'
		? true
		: false

	const isShow = (obj, actionType) => isUndefined(obj) || obj != false
		? {
			display: accessible(actionType)
		}
		: {
			display: 'none'
		}

	const TTascending = (
		<Tooltip id="tooltip">Ascending</Tooltip>
	);
	const TTdescending = (
		<Tooltip id="tooltip">Descending</Tooltip>
	);

	const renderAdditionalButtons = () => {

		return additionalButtons ? additionalButtons.map((item) => <span>&nbsp;<Button id={customButtonId} style={item.style} disabled={item.disabledState} bsStyle="primary" onClick={() => (item.func)
			? item.func({ filter, query })
			: {}}>
			{item.loaderState ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}{item.label || ''}
		</Button></span>) : ''
	}

	const sortOptions = () => {
		var options = [];
		for (var i in schema.columns) {
			console.log('column: ', schema.columns[i]);
			if (schema.columns[i].columnName.toUpperCase() !== 'OBJECTID' || schema.columns[i].type.toUpperCase() === 'BOOLEAN' || schema.columns[i].type.toUpperCase() === 'POINTER' || schema.columns[i].type.toUpperCase() === 'ARRAY' || schema.columns[i].type.toUpperCase() === 'RELATION' || schema.columns[i].type.toUpperCase() === 'OBJECT' || schema.columns[i].type.toUpperCase() === 'GEOPOPINT' || schema.columns[i].type.toUpperCase() === 'FILE') {
				options.push({ value: schema.columns[i].columnName, label: schema.columns[i].columnName.toUpperCase() });
			}
		}
		return options;
	}

	let headerProps = {
		columns: schema.columns,
		stateSetter,
		getTableData,
		loadOptions,
		accessible,
		buttonCustomId
	}
	return (
		<div>
			<Row>
				<Col md={3} className="pull-right">
					<FormGroup>
						<InputGroup style={{ zIndex: '3' }}>
							<Select placeholder="Sort by" value={sort.column} options={sortOptions()} onChange={(val) => {
								sort.column = val;
								stateSetter([
									{
										state: 'sort',
										value: sort
									}
								])
							}} />
							<InputGroup.Button>
								<Button id={customButtonId} bsStyle="primary" onClick={() => {
									if (sort.condition === 'ascending') {
										sort.condition = 'descending';
									} else {
										sort.condition = 'ascending';
									}
									stateSetter([
										{
											state: 'sort',
											value: sort
										}
									]);
								}}>
									{(sort.condition === 'ascending')
										? <OverlayTrigger placement="top" overlay={TTascending}>
											<i className="fa fa-sort-up fa-lg" style={{
												color: 'white'
											}}></i>
										</OverlayTrigger>
										: <OverlayTrigger placement="top" overlay={TTdescending}>
											<i className="fa fa-sort-down fa-lg" style={{
												color: 'white'
											}}></i>
										</OverlayTrigger>}
								</Button>
							</InputGroup.Button>
						</InputGroup>
					</FormGroup>
				</Col>
				<Col md={9}>
					<Button id={customButtonId} style={isShow(schema.showCreate, 'CREATE')} bsStyle="primary" onClick={() => (accessible('CREATE') === '')
						? (typeof customCreate !== 'undefined' && typeof customCreate === 'function'
							? customCreate()
							: handleModalShow('create'))
						: {}}>
						CREATE
					</Button>&nbsp;
					<Button id={customButtonId} style={isShow(schema.showExport, 'EXPORT')} disabled={isExporting} bsStyle="primary" onClick={() => (accessible('EXPORT') === '')
						? exportData()
						: {}}>
						{isExporting ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
						EXPORT
					</Button>
					{renderAdditionalButtons()}
				</Col>
			</Row>
			<BootstrapTable hover responsive id={customId}>
				<Header {...headerProps} />
				<Body {...bodyState} />
			</BootstrapTable>
			<div>Total Records: {count}</div>
			<Pagination {...paginationState} />
		</div>
	)
}

export default Table;



// WEBPACK FOOTER //
// ./components/zynappse-crud/Table/index.js